import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import getCurrentUser from '@core/reducers/user/selectors/getCurrentUser';

import Header from './Header';
import { HEADER_HEIGHT } from './components/HeaderContainer';

const mapDispatchToProps = {};

const mapStateToProps = createStructuredSelector({
  currentUser: getCurrentUser,
});

export { HEADER_HEIGHT };

export default connect(mapStateToProps, mapDispatchToProps)(Header);
